module.exports = __webpack_public_path__ + "img/g3.e715b381.png";